import React from 'react';
import { Message } from '@oneflowab/pomes';
import Country from 'components/countries';

// TODO: Add a type for the countries prop
type ElectronicIdCountriesProps = {
  countries: string[];
  lang: string;
}
export const ElectronicIdCountries: React.FC<ElectronicIdCountriesProps> = ({
  countries,
  lang,
}) => {
  const translatedCountryElements = countries.map((country, index) => {
    let translatedCountryElement;

    if (country === 'EU') {
      translatedCountryElement = (
        <Message
          id="EU/EEA"
          comment="Used as a country equivalent in a country list"
        />
      );
    } else {
      translatedCountryElement = Country({ country, lang });
    }
    return (
      <React.Fragment key={country}>
        {translatedCountryElement}
        {index < countries.length - 1 && ', '}
      </React.Fragment>
    );
  });

  return (
    <p>
      <Message
        id="Countries: {countries}"
        values={{
          countries: <span>{translatedCountryElements}</span>,
        }}
        comment="Help text for the electronic IDs extension."
      />
    </p>
  );
};
